module.exports = __webpack_public_path__ + "img/cg_chip.9b59b1ba.jpg";